export interface UniversityProgram {
  name: string
  category: string
}

export interface UniversityData {
  slug: string
  name: string
  mission: string
  primaryColor: string
  secondaryColor: string
  ctaColor: string
  logoText: string
  programs: UniversityProgram[]
  accreditation: string
  founded: string
  type: string
}

export const universities: Record<string, UniversityData> = {
  'colorado-technical-university': {
    slug: 'colorado-technical-university',
    name: 'Colorado Technical University',
    mission:
      'Our mission is to provide industry-relevant higher education to a diverse student population through innovative technology and experienced faculty, enabling the pursuit of personal and professional goals.',
    primaryColor: '#CC0000',
    secondaryColor: '#22c55e', // green
    ctaColor: '#f97316', // orange
    logoText: 'Colorado Technical University',
    programs: [
      { name: 'MBA', category: 'Business' },
      { name: 'Management', category: 'Business' },
      { name: 'Accounting', category: 'Business' },
      { name: 'Marketing', category: 'Business' },
      { name: 'Project Management', category: 'Business' },
      { name: 'Computer Science', category: 'IT' },
      { name: 'Cybersecurity', category: 'IT' },
      { name: 'Software Engineering', category: 'IT' },
      { name: 'Data Analytics', category: 'IT' },
      { name: 'IT Management', category: 'IT' },
      { name: 'Healthcare Management', category: 'Healthcare' },
      { name: 'Health Informatics', category: 'Healthcare' },
      { name: 'Criminal Justice', category: 'Criminal Justice' },
      { name: 'Homeland Security', category: 'Criminal Justice' },
      { name: 'Electrical Engineering', category: 'Engineering' },
      { name: 'Computer Engineering', category: 'Engineering' },
    ],
    accreditation: 'HLC Accredited',
    founded: '1965',
    type: 'Private, For-Profit',
  },
}

export const getUniversityBySlug = (slug: string) => universities[slug]
